export const NotificationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
    >
      <path
        d="M10.7972 0C5.82681 0 1.79721 4.0296 1.79721 9V14.0922L0.114811 17.9052C0.0241849 18.1107 -0.0137525 18.3355 0.00443502 18.5593C0.0226225 18.7832 0.0963603 18.9989 0.21897 19.1871C0.341579 19.3752 0.509187 19.5298 0.706612 19.6368C0.904037 19.7439 1.12504 19.7999 1.34961 19.8H20.2448C20.4694 19.7999 20.6904 19.7439 20.8878 19.6368C21.0852 19.5298 21.2528 19.3752 21.3755 19.1871C21.4981 18.9989 21.5718 18.7832 21.59 18.5593C21.6082 18.3355 21.5702 18.1107 21.4796 17.9052L19.7972 14.0922V9C19.7972 4.0296 15.7676 0 10.7972 0ZM10.7972 24C9.94637 24.0001 9.12297 23.6989 8.47308 23.1497C7.82319 22.6006 7.38882 21.8389 7.24701 21H14.3474C14.2056 21.8389 13.7712 22.6006 13.1213 23.1497C12.4715 23.6989 11.6481 24.0001 10.7972 24Z"
        fill="#333333"
      />
    </svg>
  );
};
